/// <reference path="../_references.ts"/>

module App.Helpers {

	export class PhoneHelperDirective {
		
		public link: ($scope: ng.IScope, $element: JQuery, $attrs: ng.IAttributes, ngModelCtrl: any) => void;
		public restrict: string = 'A';
		public require: string = '^ngModel';
		
		constructor($document: ng.IDocumentService, $filter: PhoneFilterService, $browser: any, PhoneConstants: PhoneConstants) {

			PhoneHelperDirective.prototype.link = ($scope: ng.IScope , $element: JQuery, $attrs: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {
				let listener = () => {
					var value: string = $element.val().replace(/[^0-9]/g, '');

					$element.val($filter('tel')(value));
				};

				// This runs when we update the text field
				ngModelCtrl.$parsers.push(function(viewValue) {
					return viewValue.replace(/[^0-9]/g, '').slice(0, PhoneConstants.DIGITS);
				});

				// This runs when the model gets updated on the scope directly and keeps our view in sync
				ngModelCtrl.$render = function() {
					$element.val($filter('tel')(ngModelCtrl.$viewValue));
				};

				$element.bind('change', listener);
				$element.bind('keydown', function(event) {
					var key = event.keyCode;

					// If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
					// This lets us support copy and paste too
					if(key === PhoneConstants.KEY_91 ||
						PhoneConstants.KEY_15 < key && key < PhoneConstants.KEY_19 ||
						PhoneConstants.KEY_37 <= key && key <= PhoneConstants.KEY_40) {
						return;
					}
					$browser.defer(listener); // Have to do this or changes don't get picked up properly
				});

				$element.bind('paste cut', function() {
					$browser.defer(listener);
				});
			}
		
		}

		public static Factory() {
			let instance = ($document: ng.IDocumentService, $filter: ng.IFilterService, $browser: any, PhoneConstants: PhoneConstants) => {
				return new PhoneHelperDirective($document, $filter, $browser, PhoneConstants);
			};

			instance.$inject = ['$document', '$filter', '$browser', 'PhoneConstants'];

			return instance;
		}
	}

	

	export interface IPhoneConstants {
		DIGITS: number;
		KEY_91: number;
		KEY_15: number;
		KEY_19: number;
		KEY_37: number;
		KEY_40: number;
		VALUE_1: number;
		VALUE_2: number;
		VALUE_3: number;
		VALUE_7: number;
	}

	export class PhoneConstants implements IPhoneConstants {
		static get getPhoneConstants() {
			return new PhoneConstants();
		}

		DIGITS: number;
		KEY_91: number;
		KEY_15: number;
		KEY_19: number;
		KEY_37: number;
		KEY_40: number;
		VALUE_1: number;
		VALUE_2: number;
		VALUE_3: number;
		VALUE_7: number;

		constructor() {
			this.DIGITS = 10;
			this.KEY_91 = 91;
			this.KEY_15 = 15;
			this.KEY_19 = 19;
			this.KEY_37 = 37;
			this.KEY_40 = 40;
			this.VALUE_1 = 1;
			this.VALUE_2 = 2;
			this.VALUE_3 = 3;
			this.VALUE_7 = 7;
		}

	}

	interface PhoneFilterService extends ng.IFilterService {
		(name: 'tel'): (tel: string) => string;
	}

	function PhoneFilter(PhoneConstants: PhoneConstants) {
		return function(tel: string) {
			if(!tel) {
				return '';
			}

			let city: string, number: string,
				value: string = tel.toString().trim().replace(/^\+/, '');

			if(value.match(/[^0-9]/)) {
				return tel;
			}

			switch(value.length) {
				case PhoneConstants.VALUE_1:
				case PhoneConstants.VALUE_2:
				case PhoneConstants.VALUE_3:
					city = value;
					break;
				default:
					city = value.slice(0, PhoneConstants.VALUE_3);
					number = value.slice(PhoneConstants.VALUE_3);
			}

			if(number) {
				if(number.length > PhoneConstants.VALUE_3) {
					number = number.slice(0, PhoneConstants.VALUE_3) + '-' + number.slice(PhoneConstants.VALUE_3, PhoneConstants.VALUE_7);
				}

				return ('(' + city + ') ' + number).trim();
			}

			return '(' + city;
		}
	}

	PhoneFilter.$inject = ['PhoneConstants'];

	angular
		.module('helpers.phone', [])
		.constant('PhoneConstants', PhoneConstants.getPhoneConstants)
		.directive('phoneHelper', ['$document', '$filter', '$browser', 'PhoneConstants', PhoneHelperDirective.Factory()])
		.filter('tel', PhoneFilter);
}
